import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';

import { initialState } from './initial';
import { reducers } from './reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const audiencesSlice = createAppSlice({
  name: 'audiences',
  initialState,
  reducers,
});

export const {
  fetchPasscodeLists,
  fetchPasscodeListMembers,
  fetchPasscodeListMemberCount,
  searchPasscodeListMembers,
  deletePasscodeList,
  setShowAddPasscodeListModal,
  fetchPaidLists,
  fetchGlobalCurrencies,
  fetchPaidListMembers,
  searchPaidListMembers,
  addPaidListMember,
} = audiencesSlice.actions;

export default audiencesSlice.reducer;
